const randomString = () => {
  return Math.random().toString();
}

export default randomString;
